const modalTypes = {
  packageModal: 'PACKAGE_MODAL',
  productModal: 'PRODUCT_MODAL',
  infoModal: 'INFO_MODAL',
  smallModal: 'SMALL_MODAL',
  errorModal: 'ERROR_MODAL',
  wideModal: 'WIDE_MODAL',
  formModal: 'FORM_MODAL',
  confirmationModal: 'CONFIRMATION_MODAL',
};

export default modalTypes;
